export const onConfirmDialogConfirm = () => ({
  widget: 'projects',
  type: 'onConfirmDialogConfirm',
  payload: {},
})



// WEBPACK FOOTER //
// ./src/projects/actions/onConfirmDialogConfirm.js